import currentEditorStore     from '@/TokamapEditor/stores/currentEditorStore';
import leftSidebarStore       from '@/TokamapEditor/stores/leftSidebarStore';
import { FormModal }          from '@widesk-ui/components/modal/FormModal';
import preventConcurrentCalls from '@/tools/preventConcurrentCalls';
import MapImagePicker         from '@/TokamapEditor/ux/MapImagePicker';

/**
 * Ouvre la modal d'image (import, ou reprise d'une image du projet) puis démarre son dessin
 * (`editor.startDrawingImage`). Partagé entre l'entrée "Image" de `ShapesButton` et le raccourci
 * clavier "I" (`useKeyboardShortcuts`).
 */
async function openImageDrawingModal() {
	const editor = currentEditorStore.get;

	leftSidebarStore.close();

	return FormModal.open({
		children: <MapImagePicker onPicked={({ src, svg }) => editor.startDrawingImage(src, { svg })} />,
		title: `Importer une image`,
	});
}

const openImportImageModal = preventConcurrentCalls(openImageDrawingModal);

export default openImportImageModal;
